interface IndexItem {
  icon: string;
  title: string;
  count: string;
  desc: string;
}

const indexItems: IndexItem[] = [
  {
    icon: 'ri-sword-line',
    title: '热血战斗',
    count: '860+ 部',
    desc: '从鬼灭之刃到咒术回战，燃爆肾上腺素的战斗盛宴。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '恋爱校园',
    count: '520+ 部',
    desc: '甜甜的恋爱与青春的校园故事，治愈你的每一天。',
  },
  {
    icon: 'ri-magic-line',
    title: '奇幻冒险',
    count: '630+ 部',
    desc: '探索魔法世界与异次元空间，开启奇妙旅程。',
  },
  {
    icon: 'ri-ghost-line',
    title: '悬疑推理',
    count: '310+ 部',
    desc: '烧脑剧情与出人意料的转折，让你停不下来。',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '搞笑日常',
    count: '480+ 部',
    desc: '轻松幽默的日常番，解压放松的最佳选择。',
  },
  {
    icon: 'ri-rocket-line',
    title: '科幻机甲',
    count: '250+ 部',
    desc: '未来科技与巨型机甲，想象力无极限。',
  },
  {
    icon: 'ri-landscape-line',
    title: '治愈系',
    count: '390+ 部',
    desc: '温暖人心的故事，让心灵得到片刻安宁。',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">主题索引</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">按题材快速找到你想看的动漫类型，海量片库分类浏览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group flex items-start gap-4 bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-10 h-10 flex-shrink-0 bg-primary-100 rounded-xl flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}